import { AlertCircleOutlineIcon } from './AlertCircleOutlineIcon';

/**
 * author: Google
 * id 0F4002B4-3C3D-43C4-939F-A998B2C59177
 * name alert-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-circle-outline.svg
 * tags
 * - Alert / Error 
 */
export const ErrorOutlineIcon = AlertCircleOutlineIcon;
export default ErrorOutlineIcon